import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Table, Spin, DatePicker, Button, Form, Modal, message,
} from "antd";
import styled from "@emotion/styled";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { CALL_FEATCH_API } from "common/API";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import TimeLogModal from "organisms/TimeLog";
import CategoriesPage from "./Categoriespage";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import COLORS from "common/Colors";
import { ReactComponent as Editicon } from "../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../assets/Trash_Full.svg";
import { ReactComponent as FilterIcon } from "../assets/filter-svgrepo-com (2).svg";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { getUserList } from "redux/selectors";
import { currencySymbolMap } from "common/Constants";

const { RangePicker } = DatePicker;

const StyledRangePicker = styled(RangePicker)`
  && {
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #d1d5db;
    box-shadow: none;
    &:hover, &:focus-within {
      border-color: #9ca3af;
      box-shadow: none;
    }
  }
`;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

const TotalLog = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
`;

const FilterModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
  margin-top: 8px;
`;

const ClearAllBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 24px;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    color: #374151;
    font-weight: 500;
    box-shadow: none;
    &:hover { border-color: #9ca3af; color: #111827; }
  }
`;

const ApplyBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 28px;
    border-radius: 6px;
    background: #00685F;
    border: none;
    color: #FFFFFF !important;
    font-weight: 600;
    box-shadow: none;
    &:hover, &:focus { background: #00685F !important; color: white !important; }
  }
`;

const RightControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const EngagementWrapper = styled.div`
  .ant-table-body {
    min-height: 300px;
    max-height: 600px !important;
  }
  @media (max-width: 1324px) {
    .ant-table-body {
      min-height: 200px;
      max-height: 300px !important;
    }
  }
  .row-actions-cell {
    display: flex;
    gap: 10px;
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .ant-table-tbody > tr:hover .row-actions-cell { opacity: 1; }
  .ant-table-tbody > tr > td { vertical-align: middle; }
`;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.15s ease;
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 560px;
  max-width: 95vw;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
  animation: slideUp 0.2s ease;
  @keyframes slideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 14px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
  border-radius: 14px 14px 0 0;
`;

const ModalTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #111827;
`;

const CloseBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  font-size: 16px;
  transition: color 0.15s, background 0.15s;
  &:hover { background: #f3f4f6; color: #374151; }
`;

const CloneBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 28px;
    border-radius: 10px;
    background: #b2f0e3;
    border: none;
    color: #111827;
    font-weight: 600;
    box-shadow: none;
    &:hover, &:focus { background: #7de8d1 !important; color: #111827 !important; }
  }
`;

const CancelBtn = styled(Button)`
  && {
    height: 38px;
    padding: 0 24px;
    border-radius: 10px;
    border: 1px solid #a6a7aa;
    color: #374151;
    font-weight: 500;
    box-shadow: none;
    &:hover { border-color: #9ca3af; color: #111827; }
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content { border-radius: 12px; }
`;

const CreatedBadge = styled.span`
  font-size: 12px;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 6px;
  padding: 3px 10px;
  font-weight: 500;
`;

const DetailBody = styled.div`
  padding: 16px 24px 24px;
`;

const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
`;

const DetailLabel = styled.span`
  width: 160px;
  flex-shrink: 0;
  color: #888;
  font-size: 13px;
  padding-top: 1px;
`;

const DetailValue = styled.span`
  color: #111;
  font-size: 13.5px;
  font-weight: 450;
  line-height: 1.65;
`;

const StyleddeactivateModal = styled(Modal)`
  .ant-modal-header { border-bottom: none; padding: 35px 0px 20px 0px; }
  .ant-modal-content { box-shadow: 0px 0px 8px #00000029; border-radius: 10px; }
  .ant-modal-title { text-align: center; font-size: 16px; font-weight: 700; color: #111827; }
  .ant-modal-body { padding: 0px 24px 28px 24px; }
  .ant-modal-close-x { display: none; }
  .ant-modal-footer { display: none; }
`;

const FilterBtn = styled.div`
  position: relative;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: #deefee;
  cursor: pointer;
  color: #6b7280;
  flex-shrink: 0;
  transition: border-color 0.2s;
`;

const FilterBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ef4444;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #fff;
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table { border: 1px solid #ccc; }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) { background-color: #fafafa; }
  .truncate-cell {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .ant-select-selector { min-width: 150px; }

  .ant-pagination-item-link { display: flex; align-items: center; justify-content: center; }
  .ant-pagination-options { display: none !important; }
`;

const FilterModalWrap = styled.div`
  padding: 8px 0 0;
`;

const FilterRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 28px;
  flex-wrap: wrap;
`;

const FilterField = styled.div`
  flex: 1;
  min-width: 180px;
`;

const FilterLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

const DEFAULT_ADV = {
  logDateRange: null,
  createdDateRange: null,
  category: [],
};

function formatDate(dateStr) {
  if (!dateStr) return "–";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11 ? "st" :
      day % 10 === 2 && day !== 12 ? "nd" :
        day % 10 === 3 && day !== 13 ? "rd" : "th";
  const month = date.toLocaleDateString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day}${suffix} ${month} ${year}`;
}

function hasDescriptionContent(description) {
  if (!description) return false;
  if (description === "<p><br></p>") return false;
  return description.replace(/<[^>]*>/g, "").trim().length > 0;
}

function formatNumber(value) {
  const n = parseFloat(value);
  if (isNaN(n)) return value;
  return n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

function DetailModal({ record, onClose, onEdit, onDelete, userInfo }) {
  if (!record) return null;

  const isOwnTimelog =
    String(record.submittedBy || "").toLowerCase() ===
    String(userInfo?.userid || "").toLowerCase();

  const isUnbilled = (record.status || "").toLowerCase() === "unbilled";

  const descHasContent = hasDescriptionContent(record.description);

  return (
    <Overlay onClick={onClose}>
      <ModalBox onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <ModalTitle>Time Logs</ModalTitle>
            <CreatedBadge style={{ alignSelf: "flex-start" }}>
              Created on &nbsp; {formatDate(record.createdat)}
            </CreatedBadge>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {(isOwnTimelog && isUnbilled) && (
              <>
                <EditOutlined
                  onClick={(e) => { e.stopPropagation(); onEdit(record); }}
                  style={{
                    color: "#00685F",
                    cursor: "pointer",
                    background: "#deefee",
                    padding: "2px",
                    borderRadius: "4px",
                    height: "25px",
                    width: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 18
                  }}
                />
                <TrashDelete
                  onClick={(e) => onDelete(e, record)}
                  style={{
                    color: "#00685F",
                    cursor: "pointer",
                    background: "#deefee",
                    padding: "2px",
                    borderRadius: "4px",
                    height: "25px",
                    width: "25px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 18
                  }}
                />
              </>
            )}
            <CloseBtn onClick={onClose}><CloseOutlined /></CloseBtn>
          </div>
        </ModalHeader>

        <DetailBody>
          {[
            ["Client", record.clientname || record.client || "–"],
            ["Matter", record.mattername || record.matter || "–"],
            ["Time Spent (Hrs)", record.timespenthours ?? record.timeSpent ?? "–"],
            ["Date of Log", formatDate(record.logdate || record.dateOfLog)],
            ["Category", record.categoryname || record.category || "–"],
            ["Rate (USD/Hr)", (() => {
              const v = record.rateperhour ?? record.rate;
              return v !== undefined && v !== null ? formatNumber(v) : "–";
            })()],
            ["Total Amount", record.totalamount != null ? `$ ${formatNumber(record.totalamount)}` : "–"],
            ["Amount in local currency", (() => {
              const amount = record?.convertedamount ?? record?.totalamount;
              if (amount === null || amount === undefined || amount === "") return "–";
              const symbol = currencySymbolMap[record?.currency] ?? record?.currency ?? "$";
              return `${symbol} ${formatNumber(amount)}`;
            })()],
          ].map(([label, value]) => (
            <DetailRow key={label}>
              <DetailLabel>{label}</DetailLabel>
              <DetailValue>{value}</DetailValue>
            </DetailRow>
          ))}

          {descHasContent ? (
            <div style={{ padding: "10px 0" }}>
              <DetailLabel style={{ display: "block", marginBottom: 6 }}>Description</DetailLabel>
              <DetailValue>
                <div
                  dangerouslySetInnerHTML={{ __html: record.description }}
                  style={{ lineHeight: 1.65, wordBreak: "break-word", whiteSpace: "normal" }}
                />
              </DetailValue>
            </div>
          ) : (
            <DetailRow>
              <DetailLabel>Description</DetailLabel>
              <DetailValue>–</DetailValue>
            </DetailRow>
          )}
        </DetailBody>
      </ModalBox>
    </Overlay>
  );
}

const TimeReport = ({ showCategories: showCategoriesProp, onShowCategoriesChange, fetchMatter }) => {
  const location = useLocation();
  const { id: matterid } = useParams();
  const [form] = Form.useForm();
  const [advForm] = Form.useForm();

  const userList = useSelector(getUserList);
  const userInfo = useSelector((store) => get(store, "common.userInfo"));
  const isMatterDetails = location.pathname.includes("matter-details");

  const debounceRef = useRef(null);
  const [filterKey, setFilterKey] = useState(0);
  const advFiltersRef = useRef(DEFAULT_ADV);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [filterListLoading, setFilterListLoading] = useState(false);
  const [filterListData, setFilterListData] = useState({
    clients: [],
    matters: [],
    statuses: [],
    submittedBy: [],
    categories: [],
  });

  const [submittedByFilter, setSubmittedByFilter] = useState([]);
  const [billedMatterFilter, setBilledMatterFilter] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [matterFilter, setMatterFilter] = useState([]);
  const [clientFilter, setClientFilter] = useState([]);
  const [billedFilter, setBilledFilter] = useState([]);
  const [detailRecord, setDetailRecord] = useState(null);
  const [showTimeLogModal, setShowTimeLogModal] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [pendingDeleteRecord, setPendingDeleteRecord] = useState(null);
  const [filterModal, setFilterModal] = useState(false);
  const [advFilters, setAdvFilters] = useState(DEFAULT_ADV);
  const [tempAdv, setTempAdv] = useState(DEFAULT_ADV);

  const [showCategoriesLocal, setShowCategoriesLocal] = useState(false);
  const showCategories = onShowCategoriesChange ? showCategoriesProp : showCategoriesLocal;
  const setShowCategories = onShowCategoriesChange ? onShowCategoriesChange : setShowCategoriesLocal;

  useEffect(() => {
    advFiltersRef.current = advFilters;
  }, [advFilters]);

  const getUserName = (userId) => {
    const user = userList?.find((u) => u.userid === userId || u.email === userId);
    return user?.name || user?.username || user?.fullname || userId || "—";
  };

  const fetchFilterList = useCallback(async () => {
    if (!userInfo?.userid) return;
    let queryparams = isMatterDetails ? `matterid=${matterid}` : `userid=${userInfo.userid}`;
    try {
      setFilterListLoading(true);
      const response = await CALL_FEATCH_API(
        `insyts-matter/gettimelogmatterfilterlist?${queryparams}`,
        "get"
      );

      if (response?.response?.code === "SUCCESS" && response?.response?.data) {
        const d = response?.response?.data;
        setFilterListData({
          clients: d.clients || [],
          matters: d.matters || [],
          statuses: d.statuses || [],
          submittedBy: d.submittedBy || [],
          categories: d.categories || [],
        });
      }
    } catch (err) {
      console.error("Failed to fetch filter list:", err);
    } finally {
      setFilterListLoading(false);
    }
  }, [userInfo]);

  const fetchTimeLogs = useCallback(async ({
    submittedBy = submittedByFilter,
    billedMatter = billedMatterFilter,
    category = categoryFilter,
    matters = matterFilter,
    clients = clientFilter,
    billeds = billedFilter,
    page = pagination.current,
    pageSize = pagination.pageSize,
    isFilterChange = false,
    logDateFrom = "__USE_REF__",
    logDateTo = "__USE_REF__",
    createdDateFrom = "__USE_REF__",
    createdDateTo = "__USE_REF__",
    advCategory = "__USE_REF__",
  } = {}) => {
    const current = advFiltersRef.current;

    const resolvedLogDateFrom = logDateFrom === "__USE_REF__"
      ? current.logDateRange?.[0]?.format("YYYY-MM-DD") : logDateFrom;
    const resolvedLogDateTo = logDateTo === "__USE_REF__"
      ? current.logDateRange?.[1]?.format("YYYY-MM-DD") : logDateTo;
    const resolvedCreatedDateFrom = createdDateFrom === "__USE_REF__"
      ? current.createdDateRange?.[0]?.format("YYYY-MM-DD") : createdDateFrom;
    const resolvedCreatedDateTo = createdDateTo === "__USE_REF__"
      ? current.createdDateRange?.[1]?.format("YYYY-MM-DD") : createdDateTo;
    const resolvedAdvCategory = advCategory === "__USE_REF__"
      ? (current.category?.length > 0 ? current.category.join(",") : undefined)
      : advCategory;

    try {
      setLoading(true);
      const userid = userInfo?.userid;
      let rows = [];
      let total = 0;
      const activePage = isFilterChange ? 1 : page;

      if (isMatterDetails && matterid) {
        const params = new URLSearchParams();
        params.set("matterid", matterid);
        params.set("mattertimelog", true);
        if (submittedBy.length > 0) params.set("submittedby", submittedBy.join(","));
        if (billedMatter.length > 0) params.set("billed", billedMatter.join(","));
        if (category.length > 0) params.set("category", category.join(","));
        if (resolvedLogDateFrom) params.set("logdatefrom", resolvedLogDateFrom);
        if (resolvedLogDateTo) params.set("logdateto", resolvedLogDateTo);
        if (resolvedCreatedDateFrom) params.set("createddatefrom", resolvedCreatedDateFrom);
        if (resolvedCreatedDateTo) params.set("createddateto", resolvedCreatedDateTo);
        if (resolvedAdvCategory) params.set("category", resolvedAdvCategory);

        const response = await CALL_FEATCH_API(`insyts-matter/gettimelog?${params.toString()}`, "get");
        if (Array.isArray(response)) { rows = response; }
        else if (response?.status === "SUCCESS" && Array.isArray(response?.response?.data)) {
          rows = response.response.data;
          total = response.response.totalCount || response.response.total;
        } else if (response?.code === "SUCCESS" && Array.isArray(response?.data)) {
          rows = response.data;
          total = response.totalCount || response.total;
        } else if (Array.isArray(response?.data)) {
          rows = response.data;
          total = response.totalCount || 0;
        }
      } else {
        const hasFilters =
          matters.length > 0 || clients.length > 0 || billeds.length > 0 ||
          resolvedLogDateFrom || resolvedLogDateTo ||
          resolvedCreatedDateFrom || resolvedCreatedDateTo || resolvedAdvCategory;

        if (hasFilters) {
          const params = new URLSearchParams();
          params.set("userid", userid);
          if (clients.length > 0) params.set("client", clients.join(","));
          if (matters.length > 0) params.set("matter", matters.join(","));
          if (billeds.length > 0) params.set("billed", billeds.join(","));
          params.set("page", activePage);
          params.set("limit", pageSize);
          if (resolvedLogDateFrom) params.set("logdatefrom", resolvedLogDateFrom);
          if (resolvedLogDateTo) params.set("logdateto", resolvedLogDateTo);
          if (resolvedCreatedDateFrom) params.set("createddatefrom", resolvedCreatedDateFrom);
          if (resolvedCreatedDateTo) params.set("createddateto", resolvedCreatedDateTo);
          if (resolvedAdvCategory) params.set("category", resolvedAdvCategory);

          const response = await CALL_FEATCH_API(`insyts-matter/gettimelogfilter?${params.toString()}`, "get");
          if (Array.isArray(response)) { rows = response; }
          else if (response?.status === "SUCCESS" && Array.isArray(response?.response?.data)) {
            rows = response.response.data;
            total = response.response.totalCount || response.response.total || rows.length;
          } else if (Array.isArray(response?.data)) {
            rows = response.data;
            total = response.totalCount || response.total || rows.length;
          }
        } else {
          const params = new URLSearchParams();
          params.set("userid", userid);
          params.set("page", activePage);
          params.set("limit", pageSize);

          const response = await CALL_FEATCH_API(`insyts-matter/gettimelog?${params.toString()}`, "get");
          if (Array.isArray(response)) { rows = response; }
          else if (response?.status === "SUCCESS" && Array.isArray(response?.response?.data)) {
            rows = response.response.data;
            total = response.response.totalCount || response.response.total || rows.length;
          } else if (response?.code === "SUCCESS" && Array.isArray(response?.data)) {
            rows = response.data;
            total = response.totalCount || response.total || rows.length;
          } else if (Array.isArray(response?.data)) {
            rows = response.data;
            total = response.totalCount || response.total || rows.length;
          }
        }
      }

      setData(rows);
      setPagination((prev) => ({ ...prev, current: activePage, total }));
    } catch (error) {
      console.error("Failed to fetch time logs:", error);
    } finally {
      setLoading(false);
    }
  }, [
    userInfo, matterid, isMatterDetails,
    submittedByFilter, billedMatterFilter, categoryFilter,
    matterFilter, clientFilter, billedFilter,
    pagination.current, pagination.pageSize,
  ]);

  useEffect(() => {
    fetchTimeLogs({
      submittedBy: [], billedMatter: [], category: [],
      matters: [], clients: [], billeds: [],
      page: 1, pageSize: pagination.pageSize, isFilterChange: false,
      logDateFrom: undefined, logDateTo: undefined,
      createdDateFrom: undefined, createdDateTo: undefined, advCategory: undefined,
    });
    fetchFilterList();
  }, [userInfo]);

  const applyFormFilters = useCallback(() => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const values = form.getFieldsValue(true);
      const current = advFiltersRef.current;
      const logDateFrom = current.logDateRange?.[0]?.format("YYYY-MM-DD");
      const logDateTo = current.logDateRange?.[1]?.format("YYYY-MM-DD");
      const createdDateFrom = current.createdDateRange?.[0]?.format("YYYY-MM-DD");
      const createdDateTo = current.createdDateRange?.[1]?.format("YYYY-MM-DD");
      const advCategory = current.category?.length > 0 ? current.category.join(",") : undefined;

      if (isMatterDetails) {
        const submittedBy = values.status ?? [];
        const billed = values.billed ?? [];
        const category = values.category ?? [];
        setSubmittedByFilter(submittedBy);
        setBilledMatterFilter(billed);
        setCategoryFilter(category);
        fetchTimeLogs({ submittedBy, billedMatter: billed, category, isFilterChange: true, logDateFrom, logDateTo, createdDateFrom, createdDateTo, advCategory });
      } else {
        const matter = values.matter ?? [];
        const client = values.client ?? [];
        const billed = values.billed ?? [];
        setMatterFilter(matter);
        setClientFilter(client);
        setBilledFilter(billed);
        fetchTimeLogs({ matters: matter, clients: client, billeds: billed, isFilterChange: true, logDateFrom, logDateTo, createdDateFrom, createdDateTo, advCategory });
      }
    }, 300);
  }, [form, isMatterDetails]);

  const openFilterModal = () => {
    setTempAdv({ ...advFilters });
    advForm.setFieldsValue({ advCategory: advFilters.category || [] });
    setFilterModal(true);
  };

  const handleAdvChange = (key, value) => {
    setTempAdv((p) => {
      const updated = { ...p, [key]: value };

      const isEmpty =
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        const applied = { ...updated };
        advFiltersRef.current = applied;
        setAdvFilters(applied);

        fetchTimeLogs({
          isFilterChange: true,
          logDateFrom: applied.logDateRange?.[0]?.format("YYYY-MM-DD"),
          logDateTo: applied.logDateRange?.[1]?.format("YYYY-MM-DD"),
          createdDateFrom: applied.createdDateRange?.[0]?.format("YYYY-MM-DD"),
          createdDateTo: applied.createdDateRange?.[1]?.format("YYYY-MM-DD"),
          advCategory:
            applied.category?.length > 0
              ? applied.category.join(",")
              : undefined,
        });
      }

      return updated;
    });
  };

  const handleApplyFilter = () => {
    const latestCategory = advForm.getFieldValue("advCategory") ?? [];
    const applied = { ...tempAdv, category: latestCategory };
    advFiltersRef.current = applied;
    setAdvFilters(applied);
    setFilterModal(false);

    fetchTimeLogs({
      isFilterChange: true,
      logDateFrom: applied.logDateRange?.[0]?.format("YYYY-MM-DD"),
      logDateTo: applied.logDateRange?.[1]?.format("YYYY-MM-DD"),
      createdDateFrom: applied.createdDateRange?.[0]?.format("YYYY-MM-DD"),
      createdDateTo: applied.createdDateRange?.[1]?.format("YYYY-MM-DD"),
      advCategory: applied.category?.length > 0 ? applied.category.join(",") : undefined,
    });
  };

  const handleClearAll = () => {
    advFiltersRef.current = { ...DEFAULT_ADV };
    setTempAdv({ ...DEFAULT_ADV });
    setAdvFilters({ ...DEFAULT_ADV });
    advForm.setFieldsValue({ advCategory: [] });
    form.setFieldsValue({ status: [], billed: [], category: [], matter: [], client: [] });
    setSubmittedByFilter([]); setBilledMatterFilter([]); setCategoryFilter([]);
    setMatterFilter([]); setClientFilter([]); setBilledFilter([]);
    setFilterModal(false);
    fetchTimeLogs({
      submittedBy: [], billedMatter: [], category: [],
      matters: [], clients: [], billeds: [],
      page: 1, pageSize: pagination.pageSize, isFilterChange: true,
      logDateFrom: undefined, logDateTo: undefined,
      createdDateFrom: undefined, createdDateTo: undefined, advCategory: undefined,
    });
  };

  const clearAllFilters = () => {
    clearTimeout(debounceRef.current);
    advFiltersRef.current = { ...DEFAULT_ADV };
    form.setFieldsValue({ status: [], billed: [], category: [], matter: [], client: [] });
    advForm.setFieldsValue({ advCategory: [] });
    setAdvFilters({ ...DEFAULT_ADV }); setTempAdv({ ...DEFAULT_ADV });
    setSubmittedByFilter([]); setBilledMatterFilter([]); setCategoryFilter([]);
    setMatterFilter([]); setClientFilter([]); setBilledFilter([]);
    setFilterKey((k) => k + 1);
    fetchTimeLogs({
      submittedBy: [], billedMatter: [], category: [],
      matters: [], clients: [], billeds: [],
      page: 1, pageSize: pagination.pageSize, isFilterChange: true,
      logDateFrom: undefined, logDateTo: undefined,
      createdDateFrom: undefined, createdDateTo: undefined, advCategory: undefined,
    });
  };

  if (showCategories) return <CategoriesPage onBack={() => setShowCategories(false)} />;

  const openEdit = (record) => { setDetailRecord(null); setEditingRecord(record); setShowTimeLogModal(true); };
  const openCreate = () => { setEditingRecord(null); setShowTimeLogModal(true); };
  const handleModalClose = () => { setShowTimeLogModal(false); setEditingRecord(null); fetchTimeLogs({}); };

  const requestDelete = (e, record) => {
    if (e) e.stopPropagation();
    setDetailRecord(null);
    setPendingDeleteRecord(record);
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = async () => {
    const record = pendingDeleteRecord;
    const id = record?.timelogid ?? record?.timeLogId ?? record?.timelog_id ?? record?.id;
    if (!id) {
      message.error("Cannot delete: record ID not found.");
      setDeleteConfirmOpen(false);
      setPendingDeleteRecord(null);
      return;
    }
    try {
      setDeletingId(id);
      const payload = { id: String(id), updatedby: userInfo?.userid || userInfo?.email || "" };
      const response = await CALL_FEATCH_API("insyts-matter/deletetimelog", "post", payload);
      if (response?.status === "SUCCESS") {
        message.success("Time log deleted successfully!");
        fetchTimeLogs({});
        if (fetchMatter) fetchMatter();
      } else {
        message.error("Failed to delete time log. Please try again.");
      }
    } catch {
      message.error("Something went wrong. Please try again.");
    } finally {
      setDeletingId(null);
      setDeleteConfirmOpen(false);
      setPendingDeleteRecord(null);
    }
  };

  const matterOptions = filterListData.matters
    .map((m) => ({ label: m, value: m }));

  const clientOptions = filterListData.clients
    .map((c) => ({ label: c, value: c }));

  const statusOptions = filterListData.statuses
    .map((s) => ({ label: s, value: s }));

  const categoryOptions = filterListData.categories
    .map((c) => ({ label: c, value: c }));

  const submittedByOptions = filterListData.submittedBy.map((u) => {
    const user = userList?.find((ul) => ul.userid === u);
    return {
      label: user?.fullname,
      value: u,
    };
  });

  const uniqueCategories = [...new Set(data.map((r) => r.categoryname || r.category).filter(Boolean))];
  const uniqueStatuses = [...new Set(data.map((r) => r.status).filter(Boolean))];

  const advFilterCount = Object.values(advFilters).filter((v) => {
    if (Array.isArray(v)) return v.length > 0;
    return v !== undefined && v !== null;
  }).length;

  const submittedByColumn = {
    title: "Submitted By",
    dataIndex: "submittedBy",
    render: (text) => <div style={{ fontWeight: 500 }}>{getUserName(text)}</div>,
  };

  const columnsdata = [
    ...(isMatterDetails ? [submittedByColumn] : []),
    ...(!isMatterDetails ? [{
      title: "Matter",
      dataIndex: "mattername",
      width: 160,
      render: (_, record) => (
        <div>
          <span className="truncate-cell" title={record.mattername || record.matter || "–"}
            style={{ fontWeight: 500, color: "#111827", lineHeight: 1.4 }}>
            {record.mattername || record.matter || "–"}
          </span>
          {record.matterid && (
            <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{record.matterid}</div>
          )}
        </div>
      ),
    }] : []),
    ...(!isMatterDetails ? [{
      title: "Client",
      dataIndex: "clientname",
      width: 120,
      render: (val, record) => (
        <span className="truncate-cell" title={val || record.client || "–"}>
          {val || record.client || "–"}
        </span>
      ),
    }] : []),
    {
      title: "Date of Log",
      dataIndex: "logdate",
      render: (val, record) => formatDate(val || record.dateOfLog || record?.dateoflog),
      width: 120,
    },
    {
      title: "Time Spent (Hrs)",
      dataIndex: "timespenthours",
      render: (val, record) => val ?? record.timeSpent ?? record?.timespent ?? "–",
      width: 140,
    },
    {
      title: "Category",
      dataIndex: "categoryname",
      render: (val, record) => (
        <span style={{ display: "block", maxWidth: 90, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          title={val || record.category || "–"}>
          {val || record.category || "–"}
        </span>
      ),
      width: 90,
    },
    {
      title: "Rate (USD/Hr)",
      dataIndex: "rateperhour",
      render: (val, record) => {
        const v = val ?? record.rate;
        return v !== undefined && v !== null ? v : "–";
      },
      width: 120,
    },
    {
      title: "Amount",
      dataIndex: "convertedamount",
      width: 140,
      render: (_, record) => {
        const amount = record?.convertedamount ?? record?.totalamount;
        if (amount === null || amount === undefined || amount === "") return "–";
        const symbol = currencySymbolMap[record?.currency] ?? record?.currency ?? "$";
        return `${symbol} ${amount}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status"
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
      align: "center",
      render: (_, record) => {
        const isOwnTimelog =
          String(record.submittedBy || "").toLowerCase() ===
          String(userInfo?.userid || "").toLowerCase();
        if (!isOwnTimelog || (record.status || "").toLowerCase() === "billed") return null;

        const id = record?.timelogid ?? record?.timeLogId ?? record?.timelog_id ?? record?.id;
        const isDeleting = deletingId === id;

        return (
          <div className="row-actions-cell" onClick={(e) => e.stopPropagation()}>
            <EditOutlined
              onClick={(e) => { e.stopPropagation(); openEdit(record); }}
              style={{
                color: "#00685F",
                cursor: "pointer",
                background: "#deefee",
                padding: "2px",
                borderRadius: "4px",
                height: "25px",
                width: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18
              }}
            />
            <TrashDelete
              onClick={(e) => requestDelete(e, record)}
              style={{
                cursor: isDeleting ? "not-allowed" : "pointer",
                color: "#00685F",
                background: "#deefee",
                padding: "2px",
                borderRadius: "4px",
                height: "25px",
                width: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                opacity: isDeleting ? 0.5 : 1,
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <EngagementWrapper>
      <Toolbar>
        <TotalLog>Total Log: {pagination.total || data.length}</TotalLog>
        <RightControls>
          <Form
            key={filterKey}
            form={form}
            layout="vertical"
            onValuesChange={applyFormFilters}
            style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}
          >
            {isMatterDetails ? (
              <>
                <div style={{ width: 180 }}>
                  <DropdownCheckBox
                    name="status"
                    label="Submitted By"
                    options={submittedByOptions}
                    form={form}
                    value={submittedByFilter}
                    handleFormChange={applyFormFilters}
                  />
                </div>
                <div style={{ width: 180 }}>
                  <DropdownCheckBox
                    name="billed"
                    label="Status"
                    options={uniqueStatuses.map((s) => ({ label: s, value: s }))}
                    form={form}
                    value={billedMatterFilter}
                    handleFormChange={applyFormFilters}
                  />
                </div>
                <div style={{ width: 180 }}>
                  <DropdownCheckBox
                    name="category"
                    label="Category"
                    options={uniqueCategories.map((c) => ({ label: c, value: c }))}
                    form={form}
                    value={categoryFilter}
                    handleFormChange={applyFormFilters}
                  />
                </div>
              </>
            ) : (
              <>
                <div style={{ width: 180 }}>
                  <DropdownCheckBox
                    name="matter"
                    label="Matter"
                    options={matterOptions}
                    form={form}
                    value={matterFilter}
                    handleFormChange={applyFormFilters}
                  />
                </div>
                <div style={{ width: 180 }}>
                  <DropdownCheckBox
                    name="client"
                    label="Client"
                    options={clientOptions}
                    form={form}
                    value={clientFilter}
                    handleFormChange={applyFormFilters}
                  />
                </div>
                <div style={{ width: 180 }}>
                  <DropdownCheckBox
                    name="billed"
                    label="Status"
                    options={statusOptions}
                    form={form}
                    value={billedFilter}
                    handleFormChange={applyFormFilters}
                  />
                </div>
              </>
            )}
          </Form>

          <div style={{ position: "relative" }}>
            <FilterBtn onClick={openFilterModal} title="Advanced Filters">
              <FilterIcon style={{ cursor: "pointer", backgroundColor: "#C2FAE5", fontSize: 20 }} />
              {advFilterCount > 0 && <FilterBadge>{advFilterCount}</FilterBadge>}
            </FilterBtn>
          </div>

          {!isMatterDetails && (
            <>
              <div style={{ width: "1px", height: "28px", background: "#e5e7eb", margin: "0 5px" }} />
              <ButtonOutlined onClick={() => setShowCategories(true)}>Categories</ButtonOutlined>
              <ButtonFilled onClick={openCreate}>Create Time Log</ButtonFilled>
            </>
          )}
        </RightControls>
      </Toolbar>

      {loading ? (
        <LoadingWrapper>
          <Spin size="large" tip="Loading time logs..." />
        </LoadingWrapper>
      ) : (
        <StyledTable
          columns={columnsdata}
          dataSource={data}
          rowKey={(_, i) => i}
          scroll={{ x: "max-content" }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: false
          }}
          onChange={(pag) => {
            setPagination((prev) => ({ ...prev, current: pag.current, pageSize: pag.pageSize }));
            fetchTimeLogs({ page: pag.current, pageSize: pag.pageSize });
          }}
          onRow={(record) => ({
            onClick: () => setDetailRecord(record),
            style: { cursor: "pointer" },
          })}
        />
      )}

      {detailRecord && (
        <DetailModal
          record={detailRecord}
          onClose={() => setDetailRecord(null)}
          onEdit={openEdit}
          onDelete={requestDelete}
          userInfo={userInfo}
        />
      )}

      <TimeLogModal
        visible={showTimeLogModal}
        onClose={handleModalClose}
        editRecord={editingRecord}
      />

      <Modal
        open={filterModal}
        onCancel={() => setFilterModal(false)}
        title={`Filter${advFilterCount > 0 ? ` (${advFilterCount})` : ""}`}
        footer={null}
        width={860}
        closable
        destroyOnClose
        centered
      >
        <FilterModalWrap>
          <FilterRow>
            <FilterField style={{ flex: 2 }}>
              <FilterLabel>Log Date Range</FilterLabel>
              <StyledRangePicker
                placeholder={["From", "To"]}
                format="DD-MM-YYYY"
                value={tempAdv.logDateRange ?? null}
                onChange={(val) => handleAdvChange("logDateRange", val ?? null)}
              />
            </FilterField>

            <FilterField style={{ flex: 2 }}>
              <FilterLabel>Created Date Range</FilterLabel>
              <StyledRangePicker
                placeholder={["From", "To"]}
                format="DD-MM-YYYY"
                value={tempAdv.createdDateRange ?? null}
                onChange={(val) => handleAdvChange("createdDateRange", val ?? null)}
              />
            </FilterField>

            {!isMatterDetails && (
              <FilterField>
                <FilterLabel>Category</FilterLabel>
                <Form form={advForm} layout="vertical">
                  <DropdownCheckBox
                    name="advCategory"
                    label="Category"
                    options={categoryOptions}
                    form={advForm}
                    value={tempAdv.category}
                    handleFormChange={() => {
                      setTimeout(() => {
                        const val = advForm.getFieldValue("advCategory") ?? [];
                        handleAdvChange("category", val);
                      }, 0);
                    }}
                  />
                </Form>
              </FilterField>
            )}
          </FilterRow>

          <FilterModalFooter>
            <ClearAllBtn onClick={handleClearAll}>Clear All</ClearAllBtn>
            <ApplyBtn onClick={handleApplyFilter}>Apply Filter</ApplyBtn>
          </FilterModalFooter>
        </FilterModalWrap>
      </Modal>

      <StyleddeactivateModal
        open={deleteConfirmOpen}
        onCancel={() => { setDeleteConfirmOpen(false); setPendingDeleteRecord(null); }}
        footer={null}
        width={500}
        closable={false}
        centered
        destroyOnClose
      >
        <div style={{ textAlign: "left", padding: "24px 16px 8px" }}>
          <p style={{ marginBottom: 32 }}>Are you sure you want to delete this Time Log?</p>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
            <CancelBtn onClick={() => { setDeleteConfirmOpen(false); setPendingDeleteRecord(null); }}
              style={{ width: 150, borderRadius: 10 }}>
              No
            </CancelBtn>
            <CloneBtn onClick={confirmDelete} style={{ width: 150 }}>Yes</CloneBtn>
          </div>
        </div>
      </StyleddeactivateModal>
    </EngagementWrapper>
  );
};

export default TimeReport;